(function() {
    'use strict';

    function initKlaviyoTracker() {
        try {
            if (typeof window._learnq === 'undefined') {
                setTimeout(initKlaviyoTracker, 500);
                return;
            }

            function trackPopupSubmission(eventData) {
                try {
                    if (!eventData) {
                        return;
                    }

                    const email = eventData.email || eventData.$email || (eventData.metaData && eventData.metaData.$email);
                    const formId = eventData.formId || eventData.form_id || 'klaviyo-popup';

                    if (!email || !window._learnq) {
                        return;
                    }

                    window._learnq.push(['track', 'Pop-up Submitted', {
                        email: email,
                        form_id: formId,
                        timestamp: new Date().toISOString(),
                        source: 'klaviyo-form',
                        popup_type: 'exit-intent'
                    }]);
                } catch (error) {
                }
            }

            function setupKlaviyoFormListener() {
                try {
                    window.addEventListener('klaviyoForms', function(event) {
                        try {
                            if (event && event.detail && event.detail.type === 'submit') {
                                const email = (event.detail.metaData && event.detail.metaData.$email) || 
                                             (event.detail.metaData && event.detail.metaData.email) ||
                                             event.detail.email;
                                const formId = event.detail.formId || 
                                              event.detail.form_id ||
                                              'klaviyo-popup';

                                trackPopupSubmission({
                                    email: email,
                                    formId: formId,
                                    metaData: event.detail.metaData
                                });
                            }
                        } catch (error) {
                        }
                    });

                    try {
                        const observer = new MutationObserver(function(mutations) {
                            try {
                                if (!document.querySelectorAll) {
                                    return;
                                }

                                const klaviyoForms = document.querySelectorAll('[data-testid^="klaviyo-form-"]');
                                
                                if (klaviyoForms && klaviyoForms.length > 0) {
                                    for (let i = 0; i < klaviyoForms.length; i++) {
                                        const form = klaviyoForms[i];
                                        
                                        try {
                                            if (form && (form.classList.contains('klaviyo-form-submitted') || 
                                                form.querySelector('.klaviyo-form-success'))) {
                                                
                                                const emailInput = form.querySelector('input[type="email"]');
                                                const email = emailInput ? emailInput.value : null;
                                                
                                                if (email) {
                                                    const formIdAttr = form.getAttribute('data-testid');
                                                    const formId = formIdAttr ? formIdAttr.replace('klaviyo-form-', '') : 'klaviyo-popup';

                                                    trackPopupSubmission({
                                                        email: email,
                                                        formId: formId
                                                    });
                                                    
                                                    if (form.classList) {
                                                        form.classList.add('klaviyo-popup-tracked');
                                                    }
                                                }
                                            }
                                        } catch (error) {
                                        }
                                    }
                                }
                            } catch (error) {
                            }
                        });

                        if (document.readyState === 'loading') {
                            document.addEventListener('DOMContentLoaded', function() {
                                try {
                                    observer.observe(document.body, {
                                        childList: true,
                                        subtree: true
                                    });
                                } catch (error) {
                                }
                            });
                        } else {
                            try {
                                observer.observe(document.body, {
                                    childList: true,
                                    subtree: true
                                });
                            } catch (error) {
                            }
                        }
                    } catch (error) {
                    }
                } catch (error) {
                }
            }

            function interceptKlaviyoTracking() {
                try {
                    if (!window._learnq || !window._learnq.push) {
                        return;
                    }

                    const originalPush = window._learnq.push;
                    
                    window._learnq.push = function() {
                        try {
                            const result = originalPush.apply(this, arguments);
                            
                            if (arguments.length > 0 && arguments[0] === 'track') {
                                const eventName = arguments[1];
                                const eventData = arguments[2];
                                
                                if (eventName && eventData && eventData.$email) {
                                    if (eventName !== 'Pop-up Submitted') {
                                        setTimeout(function() {
                                            try {
                                                trackPopupSubmission({
                                                    email: eventData.$email || eventData.email,
                                                    formId: 'klaviyo-popup'
                                                });
                                            } catch (error) {
                                            }
                                        }, 100);
                                    }
                                }
                            }
                            
                            return result;
                        } catch (error) {
                            try {
                                return originalPush.apply(this, arguments);
                            } catch (originalError) {
                                return undefined;
                            }
                        }
                    };
                } catch (error) {
                }
            }

            setupKlaviyoFormListener();
            interceptKlaviyoTracking();

            try {
                document.addEventListener('submit', function(event) {
                    try {
                        if (!event || !event.target) {
                            return;
                        }

                        const form = event.target;
                        const formTestId = form ? form.getAttribute('data-testid') : null;
                        
                        if (formTestId && formTestId.startsWith('klaviyo-form-')) {
                            const emailInput = form.querySelector('input[type="email"]');
                            
                            if (emailInput && emailInput.value) {
                                const formId = formTestId.replace('klaviyo-form-', '');
                                
                                setTimeout(function() {
                                    try {
                                        trackPopupSubmission({
                                            email: emailInput.value,
                                            formId: formId
                                        });
                                    } catch (error) {
                                    }
                                }, 500);
                            }
                        }
                    } catch (error) {
                    }
                }, true);
            } catch (error) {
            }
        } catch (error) {
        }
    }

    try {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() {
                try {
                    initKlaviyoTracker();
                } catch (error) {
                }
            });
        } else {
            initKlaviyoTracker();
        }

        try {
            setTimeout(function() {
                try {
                    initKlaviyoTracker();
                } catch (error) {
                }
            }, 1000);
        } catch (error) {
        }

        try {
            setTimeout(function() {
                try {
                    initKlaviyoTracker();
                } catch (error) {
                }
            }, 3000);
        } catch (error) {
        }
    } catch (error) {
    }
})();